export default __webpack_public_path__ + "static/media/uploader-insuletOmnipod-problem-1.299c0a14.png";